import { hasWindow } from "@omni/utils/dom.utils";

import createValueModule from "@/redux/create-value-module";
import { isModalId } from "@/redux/modules/value/modal/helpers/modal.helpers";

import { $ModalModuleName, TModalState } from "./modal.types";

const getInitialState = (): TModalState => {
    if (!hasWindow()) return [];

    const hash = window.location.hash.substring(1);

    return isModalId(hash) ? [hash] : [];
};

const { constants: _constants, actions } = createValueModule<TModalState>(
    $ModalModuleName,
    getInitialState()
);

export const clear = actions.clear;
export const set = actions.set;
